import { render, staticRenderFns } from "./BrandingTab.vue?vue&type=template&id=5ccdbaa3&scoped=true"
import script from "./BrandingTab.vue?vue&type=script&lang=js"
export * from "./BrandingTab.vue?vue&type=script&lang=js"
import style0 from "./BrandingTab.vue?vue&type=style&index=0&id=5ccdbaa3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccdbaa3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ccdbaa3')) {
      api.createRecord('5ccdbaa3', component.options)
    } else {
      api.reload('5ccdbaa3', component.options)
    }
    module.hot.accept("./BrandingTab.vue?vue&type=template&id=5ccdbaa3&scoped=true", function () {
      api.rerender('5ccdbaa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/BrandingTab.vue"
export default component.exports